// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Person40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Person40Filled: FC<Person40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M20 19.972c-1.833 0-3.357-.606-4.57-1.819-1.212-1.213-1.819-2.736-1.819-4.57 0-1.833.607-3.356 1.82-4.569s2.736-1.82 4.569-1.82c1.833 0 3.357.607 4.57 1.82 1.212 1.213 1.819 2.736 1.819 4.57 0 1.833-.607 3.356-1.82 4.57-1.212 1.212-2.736 1.818-4.569 1.818ZM6.667 33.334v-4.167c0-1.019.257-1.91.77-2.674a5 5 0 0 1 2.008-1.743c1.814-.842 3.587-1.474 5.319-1.896A22.07 22.07 0 0 1 20 22.222c1.76 0 3.5.216 5.222.646 1.722.43 3.49 1.058 5.306 1.882a4.96 4.96 0 0 1 2.035 1.743c.513.764.77 1.655.77 2.674v4.167H6.667Z" />
        </svg>
    );
};

export default Person40Filled;
